if (!customElements.get('td-variant-picker-grouped')) {
  customElements.define(
    'td-variant-picker-grouped',
    class TdVariantPickerGrouped extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.variantSelects = this.closest('variant-selects');
        if (!this.variantSelects) return;

        this.colorOptionName = this.dataset.colorOptionName;
        this.coreSelected = this.querySelector('[data-group-selected-value="core"]');
        this.limitedSelected = this.querySelector('[data-group-selected-value="limited_edition"]');

        this.variantSelects.addEventListener('change', this.onChange);
        this.updateSelectedValue();
      }

      disconnectedCallback() {
        if (this.variantSelects) {
          this.variantSelects.removeEventListener('change', this.onChange);
        }
      }

      onChange(event) {
        if (!this.colorOptionName) return;

        if (event.target?.matches(`input[type="radio"][name="${CSS.escape(this.colorOptionName)}"]`)) {
          this.updateSelectedValue();
        }
      }

      updateSelectedValue() {
        if (!this.colorOptionName) return;

        const selectedInput = this.variantSelects.querySelector(
          `input[type="radio"][name="${CSS.escape(this.colorOptionName)}"]:checked`
        );

        if (!selectedInput) return;

        const selectedValue = selectedInput.dataset.variantColorValue || selectedInput.value || '';
        const selectedCategory = selectedInput.dataset.variantCategory || 'core';

        if (this.coreSelected) {
          this.coreSelected.textContent = selectedCategory === 'core' ? selectedValue : '';
        }

        if (this.limitedSelected) {
          this.limitedSelected.textContent = selectedCategory === 'limited_edition' ? selectedValue : '';
        }
      }
    }
  );
}
